export default {"src":"/_next/static/media/light-purple-right.c29542db.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};